var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:[
      _vm.istransparent ? 'header-info-nav' : 'header-info-nav-notransparent',
      {
        'header-info-nav-fix': _vm.navBarFixed,
        'padding-top': _vm.$isInApp,
      } ]},[_c('div',{class:[
        'header-info-nav__left',
        {
          'header-info-nav__left_two': !_vm.istransparent,
          'header-info-nav__left_wihte': _vm.isHomePage,
        } ],on:{"click":function($event){$event.stopPropagation();return _vm.goBack()}}}),(_vm.title)?_c('div',{class:[
        _vm.fontSize,
        _vm.istransparent
          ? 'header-info-nav__text'
          : 'header-info-nav-notransparent__text' ]},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),(_vm.istransparent)?_c('div',{class:[
        'header-info-nav__right',
        {
          'header-info-nav__right_wihte': _vm.isHomePage,
        } ],on:{"click":function($event){$event.stopPropagation();return _vm.sharePage.apply(null, arguments)}}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }